import { dataTransferWrap } from './../dataTransferService';
import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorksStaffPaymentRatesNorms(companyId, cashedPayload) {
    return dataTransferWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,dtConfig[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].getWorksStaffPaymentRatesNorms,
        {
            urlParams: {
                companyId
            },
        },
        cashedPayload
    )
}

function getWorksStaffPaymentRatesNorm(companyId, worksStaffPaymentRatesNormId) {
    return dataTransferWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,dtConfig[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].getWorksStaffPaymentRatesNorm,
        {
            urlParams: {
                companyId,
                worksStaffPaymentRatesNormId
            }
        }
    )
}

function createWorksStaffPaymentRatesNorm(companyId, data) {
    return dataTransferWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,dtConfig[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].createWorksStaffPaymentRatesNorm,
        {
            urlParams: {
                companyId
            },
            ...data
        }
    )
}

function putWorksStaffPaymentRatesNorm(companyId, worksStaffPaymentRatesNormId, data) {
    return dataTransferWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,dtConfig[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].putWorksStaffPaymentRatesNorm,
        {
            urlParams: {
                companyId,
                worksStaffPaymentRatesNormId
            },
            ...data
        },
    )
}

function patchWorksStaffPaymentRatesNorm(companyId, worksStaffPaymentRatesNormId, data) {
    return dataTransferWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,dtConfig[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].patchWorksStaffPaymentRatesNorm,
        {
            urlParams: {
                companyId,
                worksStaffPaymentRatesNormId
            },
            ...data
        }
    )
}

function deleteWorksStaffPaymentRatesNorm(companyId, worksStaffPaymentRatesNormId) {
    return dataTransferWrap(
        ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS,dtConfig[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS].deleteWorksStaffPaymentRatesNorm,
        {
            urlParams: {
                companyId,
                worksStaffPaymentRatesNormId
            }
        }
    )
}

export default {
    getWorksStaffPaymentRatesNorms,
    getWorksStaffPaymentRatesNorm,
    createWorksStaffPaymentRatesNorm,
    putWorksStaffPaymentRatesNorm,
    patchWorksStaffPaymentRatesNorm,
    deleteWorksStaffPaymentRatesNorm,
}